var React = require('react');

function CircleArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"19.2148","cy":"19","r":"18.25","transform":"rotate(-180 19.2148 19)","stroke":"#151515","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M20.6424 24L19.5692 22.9325L22.8091 19.6999L12.7148 19.6999L12.7148 18.1994L22.8192 18.1893L19.6603 15.0574L20.7335 14L25.7148 18.9345L20.6424 24Z","fill":"#151515","key":1})]);
}

CircleArrow.defaultProps = {"width":"39","height":"38","viewBox":"0 0 39 38","fill":"none"};

module.exports = CircleArrow;

CircleArrow.default = CircleArrow;
